var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelFlickrFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  x: 3,
  y: 3,
  fill: "#FD0084",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M15.214 9.429a2.571 2.571 0 1 1 0 5.142 2.571 2.571 0 0 1 0-5.142m-6.428 0a2.571 2.571 0 1 1 0 5.142 2.571 2.571 0 0 1 0-5.142m6.428 1.285a1.286 1.286 0 1 0 0 2.572 1.286 1.286 0 0 0 0-2.572"
}))));
export default SvgGemChannelFlickrFilled;